import React from 'react';
import './PetAnimations.css';

export default function PigSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#F0A0A0';
  const lightColor = color ? lighten(color) : '#F8C4C4';
  const darkColor = color ? darken(color) : '#D07878';
  const snoutColor = '#E88888';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Curly tail */}
      <path
        d="M88 68C94 66 98 60 96 56C94 52 90 56 92 60C94 64 90 68 86 66"
        stroke={darkColor}
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      {/* Body */}
      <ellipse cx="58" cy="72" rx="30" ry="24" fill={bodyColor} />
      {/* Belly */}
      <ellipse cx="58" cy="76" rx="18" ry="14" fill={lightColor} />
      {/* Back legs */}
      <rect x="36" y="88" width="10" height="14" rx="4" fill={bodyColor} />
      <rect x="68" y="88" width="10" height="14" rx="4" fill={bodyColor} />
      {/* Front hooves */}
      <rect x="36" y="98" width="10" height="4" rx="2" fill={darkColor} />
      <rect x="68" y="98" width="10" height="4" rx="2" fill={darkColor} />
      {/* Head */}
      <ellipse cx="58" cy="42" rx="22" ry="20" fill={bodyColor} />
      {/* Ears */}
      <ellipse cx="40" cy="28" rx="8" ry="6" fill={bodyColor} transform="rotate(-20 40 28)" />
      <ellipse cx="40" cy="28" rx="5" ry="4" fill={darkColor} transform="rotate(-20 40 28)" />
      <ellipse cx="76" cy="28" rx="8" ry="6" fill={bodyColor} transform="rotate(20 76 28)" />
      <ellipse cx="76" cy="28" rx="5" ry="4" fill={darkColor} transform="rotate(20 76 28)" />
      {/* Face */}
      <ellipse cx="58" cy="46" rx="14" ry="10" fill={lightColor} />
      {/* Snout */}
      <ellipse cx="58" cy="50" rx="10" ry="7" fill={snoutColor} />
      {/* Nostrils */}
      <ellipse cx="54" cy="50" rx="2.5" ry="2" fill={darkColor} />
      <ellipse cx="62" cy="50" rx="2.5" ry="2" fill={darkColor} />
      {/* Eyes */}
      <circle cx="50" cy="38" r="4" fill="white" />
      <circle cx="66" cy="38" r="4" fill="white" />
      <circle cx="51" cy="38" r="2.5" fill="#2C2419" />
      <circle cx="67" cy="38" r="2.5" fill="#2C2419" />
      <circle cx="52" cy="37" r="1" fill="white" />
      <circle cx="68" cy="37" r="1" fill="white" />
      {/* Mouth */}
      <path d="M54 55C56 57 60 57 62 55" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
